<template>
  <div>
    <div
      v-if="$store.state.user"
      class="general-page"
    >
      <h1>
        Hi {{ $store.state.user.name }}

        <router-link
          :to="{ name: 'login' }"
          style="font-size:12px;cursor:pointer;color: #ff7353;"
        >
          not you?
        </router-link>
      </h1>

      <div class="qform2022 full">
        <p
          v-if="first(errors) || errors.recaptcha_response"
          class="notice error live"
        >
          <span class="icon-attention redicon" />
          {{ first(errors) }}
          <router-link
            v-if="errors.password"
            class="normal-link"
            :to="{ name: 'forgotten-password' }"
          >
            Click to reset your password.
          </router-link>
        </p>

        <template v-if="first(errors) && first(errors).includes('expire')">
          <router-link
            class="button"
            :to="{ name: 'login' }"
          >
            Restart session
          </router-link>
        </template>
        <form
          v-else
          @submit.prevent="post"
        >
          <div class="generic-inputs">
            <label>Your password*</label>
            <input
              v-model="password"
              :type="[show_password ? 'text' : 'password']"
              autocomplete="current-password"
              placeholder="Password"
              name="password"
            >
            <router-link
              class="forgotpass"
              :to="{ name: 'forgotten-password', query: {email: $store.state.user.username} }"
            >
              Forgotten Password?
            </router-link>
          </div>

          <div class="generic-inputs">
            <div
              class="terms-container checkbox terms-checkbox"
              style="margin-top: 0px"
              :class="{ 'active': show_password }"
              @click="toggleShowPassword"
            >
              <div class="checkbox" />
              <input
                type="hidden"
                name="show_password"
                value=""
              >
              <p>Show password</p>
            </div>
          </div>

          <div v-if="recaptchaFields.required">
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaKey"
              @verify="recaptchaCompleted"
            />
            <br>
          </div>

          <div
            v-if="loading"
            class="twobuttons"
          >
            <img
              src="/assets/images/loading.gif"
              style="width:200px;"
            >
          </div>
          <div
            v-else
            class="twobuttons"
          >
            <button class="button">
              Login
            </button>
            <span>or</span>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'magic-link', query: {email: $store.state.user.username}}"
              custom
            >
              <button
                class="button clear"
                @click="navigate"
              >
                Email me a link to login
              </button>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const loading = ref(false);
        const show_password = ref(false);
        const password = ref(null);
        const errors = ref([]);
        const router = useRouter();
        const store = useStore();
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const toggleShowPassword = () => {
            show_password.value = !show_password.value;
        };

        onMounted(() => {
            if (!store.state.user) {
                router.push({ name: 'login' });
            }

            loadRecaptcha();
        });

        const post = () => {
            loading.value = true;
            errors.value = [];

            const data = {
                username: store.state.user.username,
                recaptcha_response: recaptchaFields.response,
                password: password.value
            };

            axios({
                method: 'post',
                url: store.state.user.route,
                data: data
            }).then(response => {
                if (!response.data.success) {
                    errors.value = response.data.errors;

                    if (errors.value && errors.value.recaptcha_response) {
                        recaptchaFields.required = true;
                    }
                    loading.value = false;
                } else {
                    window.location = response.data.url;
                    setTimeout(() => {
                        loading.value = false;
                    }, 5000);
                }
            }).catch(() => {
                errors.value = { general: ['Something went wrong; please try again later.'] };
                loading.value = false;
            }).then(() => {
                resetCaptcha();
            });
        };

        const loadRecaptcha = () => {
            axios({
                method: 'get',
                url: `/auth/password/captcha`,
            }).then(response => {
                if (response.data.captcha) {
                    recaptchaFields.required = true;
                } else {
                    recaptchaFields.required = false;
                }
            }).catch(error => {
                console.log(error);
                recaptchaFields.required = false;
            });
        };

        return {
            loading,
            show_password,
            password,
            errors,
            post,
            loadRecaptcha,
            toggleShowPassword,
            recaptchaKey,
            first,
            recaptchaCompleted,
            recaptchaFields
        };
    }
}
</script>
